/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Vue} from 'vue-property-decorator';
import Vuex, {ModuleTree, Store} from 'vuex';
import {RootState} from './types';
import {userSessionModule} from '@/store/modules/user-session';
import {settingsModule} from '@/store/modules/settings';
import {gameModule} from '@/store/modules/game';
import SubscriberLocalstorage from '@/store/subscribers/localstorage';
import {communityChallengeModule} from '@/store/modules/community-challenge';
import {communityChallengesModule} from '@/store/modules/community-challenges';
import {trophyCabinetModule} from '@/store/modules/trophy-cabinet';

Vue.use(Vuex);

/**
 * Vuex entry point.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

/**
 * The user session store module.
 *
 * This module is imported by vuex as a representation of the user session.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const state: RootState = {
    version: '1.0.0',
    build: process.env.VUE_APP_COMMIT || 'development',
};

const modules: ModuleTree<RootState> = {
    userSessionModule,
    settingsModule,
    gameModule,
    communityChallengeModule,
    communityChallengesModule,
    trophyCabinetModule,
};

const store: Store<RootState> = new Vuex.Store<RootState>({
    state,
    modules,
});

// setup module subscribers
store.subscribe(SubscriberLocalstorage);

// load in modules that exist in local storage
for (const module of Object.keys(modules)) {
    if (!module.match(/^.+module$/i)) {
        continue;
    }
    const version: string = localStorage.getItem(`planet-zoo/store/${module}/version`) || '';
    if (version !== state.version) {
        continue;
    }

    const moduleState: string = localStorage.getItem(`planet-zoo/store/${module}`) || '';
    if (moduleState.length > 0) {
        Object.assign(modules[module]['state'], JSON.parse(moduleState));
    }
}

export default store;

